import { RootState } from '@/Redux/RootReducer';
import { createSelector } from 'reselect';
import { UploadTemplatesDataState } from './reducer';

const uploadTemplatesData = (root: RootState) => root.dynamicData.uploadTemplatesData;

const selectedUploadTemplate = createSelector(uploadTemplatesData, (state) => state.selectedTemplate);

const uploadTemplateModal = createSelector(uploadTemplatesData, (state) => state.uploadTemplateModal);

const uploadTemplates = createSelector(uploadTemplatesData, (state: UploadTemplatesDataState) => state.uploadTemplates);

export const uploadTemplatesDataSelectors = {
  uploadTemplates,
  selectedUploadTemplate,
  uploadTemplateModal,
};
